'use strict';
import angular from 'angular';
import _ from 'lodash';

import mobileAppHtmlUrl from './views/mobileApp.list.html';

var app = angular.module('mobileApp.component', []);

app.component('mobileApp', {
    bindings: {
        showActions: '=',
        selectedApps: '=',
        clusterId: '='
    },
    templateUrl: mobileAppHtmlUrl,

    // The controller that handles our component logic
    controller: function(ProductService, FormService) {
        var self = this;
        self.mobileAppSearch = "";
        self.mobileAppWidget = [];
        self.includeOrExcludeMobileApp = null;
        var mobileAppCount = 0;
        var contentKey = "dfp_mobile_applications";

        self.mobileApps = [];

        self.changeMobileAppIncludeExclude = function(item, criteria, data, type) {
            self.mobileAppWidget = data;
            var index = self.mobileAppWidget.indexOf(item);
            if (index >= 0) {
                if (criteria == "include") {
                    self.mobileAppWidget[index].criteria = 'include';
                    self.mobileAppWidget[index].criteria_link = 'included';
                } else if (criteria == "exclude") {
                    self.mobileAppWidget[index].criteria = 'exclude';
                    self.mobileAppWidget[index].criteria_link = 'excluded';
                } else {
                    self.mobileAppWidget[index].criteria = '';
                    self.mobileAppWidget[index].criteria_link = 'include';
                }

                if(type === 'mobileApps') {
                    if(mobileAppCount < 1) {
                        self.includeOrExcludeMobileApp = criteria + 'apps';
                    }
                    var selIndex = _.findIndex(self.selectedApps.mobileApps, { id: self.mobileAppWidget[index].id });
                    if (selIndex >= 0) {
                        self.selectedApps.mobileApps[selIndex] = self.mobileAppWidget[index];
                    } else {
                        self.selectedApps.mobileApps.push(self.mobileAppWidget[index]);
                    }
                    mobileAppCount++;
                }      
            }
        }

        self.removeConnection = function(item, selectedApp, appsData, type) {
            var selIndex = selectedApp.indexOf(item);
            if (selIndex >= 0) {
                selectedApp.splice(selIndex, 1);
                if(selIndex === 0 && selectedApp.length == 0) {
                    if(type === 'mobileApps') {
                        mobileAppCount = 0;
                        self.includeOrExcludeMobileApp = null;
                    }
                }
            }
            var index = _.findIndex(appsData, { id: item.id });
            if (index >= 0) {
                appsData[index].criteria = '';
                appsData[index].criteria_link = 'include';
            }
        }

        self.clearSelectedData = function(){
            self.selectedApps.mobileApps = [];
            mobileAppCount = 0;
            self.includeOrExcludeMobileApp = null;
            _.map(self.mobileApps, function (item) {
                item.criteria = '';
                item.criteria_link = 'include';
            });
        }

        /*
        * get mobile apps lookup contents
        */
        self.getMobileAppsByContentKey = function() {
            ProductService.getMobileAppsByContentKey({clusterId: self.clusterId, contentKey: contentKey}).then(function(success) {
                if(success && success.lookupContents && success.lookupContents.length > 0) {
                    _.each(success.lookupContents, function(content) {
                        var mobileApp = {};
                        mobileApp.id = content.id;
                        mobileApp.name = content.lookup_value;
                        mobileApp.criteria = "";
                        mobileApp.criteria_link = "include";
                        self.mobileApps.push(mobileApp);
                    })
                    if(self.editMode && self.selectedApps) {
                        var appsList = [];
                        var subList = [];

                        if(self.selectedApps.mobileApps && self.selectedApps.mobileApps.length > 0) {
                            if(contentKey === 'dfp_mobile_applications') {
                                appsList = self.mobileApps;
                                subList = self.selectedApps.mobileApps;
                                self.includeOrExcludeMobileApp = subList[0].criteria + 'apps';
                            }
                            processMobileApps(appsList, subList);
                        }
                    }
                }
            }, function(error) {});
        }

        var processMobileApps = function(totalList, subList) {
            if(totalList && subList) {
                _.each(totalList, function(app) {
                    _.each(subList, function(subApp) {
                        if(subApp.id == app.id) {
                            app.criteria = subApp.criteria;
                            app.criteria_link = subApp.criteria_link;
                        }
                    })
                })
            }
        }
        
        self.initComponent = function() {
            if(self.selectedApps && !_.isEmpty(self.selectedApps)){
                if(FormService.isValidJsonString(self.selectedApps)){
                    self.selectedApps = JSON.parse(self.selectedApps);
                }
                if(self.showActions){
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getMobileAppsByContentKey();
                }else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            }else {
                self.selectedApps = {
                    mobileApps: []
                };
                self.enableViewMode = false;
                self.getMobileAppsByContentKey();
            }
        };

        self.initComponent();
    }
});